// https://turbo.hotwired.dev/handbook/building#opting-out-of-caching-from-the-client-side
document.addEventListener("turbo:load", function() {
  if (document.querySelector(".turbo-no-cache")) Turbo.cache.exemptPageFromCache()
  if (document.querySelector(".turbo-no-preview")) Turbo.cache.exemptPageFromPreview()

  document.addEventListener("turbo:before-cache", function () {
    // Alle Modals entfernen
    document.querySelector("#remote-modal .modal")?.remove();

    cleanupTooltips()
  })


  document.addEventListener("turbo:before-stream-render", () => {
    cleanupTooltips()
    initTooltips()
  })

  const initTooltips = () => {
    if (!window.bootstrap?.Tooltip) return
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => new window.bootstrap.Tooltip(el))
  }

  const cleanupTooltips = () => {
    if (!window.bootstrap?.Tooltip) return
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => window.bootstrap.Tooltip.getInstance(el)?.dispose())
  }
})
